
/** 军事类 */
export namespace MilitaryKind {

    /** 通用数值 */  
    export enum GeneralValue {
        /** 每次刷新武将数量 */
        EVERY_REFRESH_OFFICER_COUNT = 3,
        /** 丢城刷新天数 */
        DROP_CITY_REFRESH_DAY = 3,
    }

}